import React from "react";
import styles from "./email-form.module.scss";

function Step({ index, title, optional = false }) {
  return (
    <div className={styles["step-container"]}>
      <div className={styles["step-item"]}>{index}</div>
      <h3 className={styles["step-label"]}>
        {title}
        {optional ? <span>(Optional)</span> : null}
      </h3>
    </div>
  );
}

export default Step;
